import { createSlice } from '@reduxjs/toolkit'

const SearchFilterSlices = createSlice({
    name: 'searchFilter',
    initialState: {
        search: '',
        status: '',
        commerce: '',
    },

    reducers: {
        addFilter: (state, action) => ({
            ...state,
            search: action.payload
        }),
        addStatusFilter: (state, action) => ({
            ...state,
            status: action.payload
        }),
        addCommerceFilter: (state, action) => ({
            ...state,
            commerce: action.payload
        }),
        resetFilters: () => ({
            search: '',
            status: '',
            commerce: '',
        }),
    }
})

export const { addFilter, addStatusFilter, addCommerceFilter, resetFilters } = SearchFilterSlices.actions
export default SearchFilterSlices.reducer
